var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ui-selection ui-selection-action"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutside,
      expression: "clickOutside"
    }],
    ref: "select",
    staticClass: "ui-selection-action__wrapper w-100",
    class: _vm.selectClasses
  }, [_c('button', {
    ref: "button",
    staticClass: "ui-selection-action__button ui-button--secondary ui-button--block",
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "type": "button",
      "aria-controls": _vm.id,
      "aria-expanded": _vm.isShowList ? 'true' : 'false',
      "role": "combobox",
      "aria-labelledby": _vm.labelId
    },
    on: {
      "click": _vm.toggleDropDown,
      "focus": function ($event) {
        _vm.isFocused = true;
      },
      "blur": function ($event) {
        _vm.isFocused = false;
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.toggleDropDown(true);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.toggleDropDown(true);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return function () {
          if (_vm.isShowList) {
            _vm.setFocus(0);
          } else {
            _vm.toggleDropDown(true);
          }
        }.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.toggleDropDown(true);
      }]
    }
  }, [_c('UiSmartIcon', {
    staticClass: "ui-button__icon ui-button__icon--prepend",
    attrs: {
      "name": _vm.titleIconBefore,
      "size": 15
    }
  }), _c('div', {
    staticClass: "ui-selection-action__button--title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('UiSmartIcon', {
    staticClass: "ui-button__icon ui-button__icon--prepend",
    attrs: {
      "name": _vm.titleIconAfter,
      "size": 15
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    ref: "floating",
    staticClass: "ui-select-new__dropdown custom-scrollbar custom-scrollbar--small",
    class: {
      'ui-select-new__dropdown--open': _vm.isShowList
    },
    style: _vm.floatingStyle
  }, [_c('ul', {
    staticClass: "ui-select-new__dropmenu",
    attrs: {
      "tabindex": "-1"
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('li', {
      key: ("ui-select-" + index),
      ref: "options",
      refInFor: true,
      staticClass: "ui-select-new__dropmenu-item",
      attrs: {
        "role": "option",
        "aria-selected": "false",
        "tabindex": "0"
      },
      on: {
        "click": function ($event) {
          return _vm.onSelect(option);
        },
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          $event.preventDefault();
          return _vm.onSelect(option);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          $event.preventDefault();
          return _vm.onSelect(option);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          $event.preventDefault();
          return _vm.setFocus(index + 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          $event.preventDefault();
          return _vm.setFocus(index - 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          if (!$event.altKey) { return null; }
          $event.preventDefault();
          _vm.onSelect(option), _vm.setFocus(-1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          $event.preventDefault();
          _vm.toggleDropDown(false), _vm.setFocus(-1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.closeIfLast(index);
        }]
      }
    }, [option.prependIcon ? _c('UiSmartIcon', {
      staticClass: "ui-button__icon ui-button__icon--prepend",
      attrs: {
        "name": option.prependIcon,
        "size": 18,
        "color": "#2B2B2B"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(option.label) + " ")], 1);
  }), 0)])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }